import TextLookup from './textLookup.js';
export default TextLookup;
